import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17d68c89"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vld-parent" }, null, -1))
const _hoisted_2 = {
  key: 0,
  class: "background"
}
const _hoisted_3 = { class: "detail-main-box" }
const _hoisted_4 = { class: "detail-main-title" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "detail-main-model" }
const _hoisted_7 = { class: "detail-model-name" }
const _hoisted_8 = {
  key: 0,
  class: "detail-main-normal"
}
const _hoisted_9 = { class: "detail-status-text" }
const _hoisted_10 = {
  key: 1,
  class: "detail-main-error"
}
const _hoisted_11 = { class: "detail-status-text" }
const _hoisted_12 = {
  key: 2,
  class: "detail-main-warning"
}
const _hoisted_13 = { class: "detail-status-text" }
const _hoisted_14 = { class: "detail-main-switch detail-main-side" }
const _hoisted_15 = { class: "detail-box-title" }
const _hoisted_16 = { class: "detail-main-cycle-status detail-main-side" }
const _hoisted_17 = { class: "detail-box-title" }
const _hoisted_18 = { class: "detail-main-cycle-count detail-main-side" }
const _hoisted_19 = { class: "detail-box-title" }
const _hoisted_20 = { class: "main-side-data" }
const _hoisted_21 = { class: "detail-main-drytime detail-main-side" }
const _hoisted_22 = { class: "detail-box-title" }
const _hoisted_23 = { class: "main-side-data" }
const _hoisted_24 = { class: "detail-main-distime detail-main-side" }
const _hoisted_25 = { class: "detail-box-title" }
const _hoisted_26 = { class: "main-side-data" }
const _hoisted_27 = { class: "warning-list-box" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "warning-list-title-box" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "warning-list-title-text" }, "Error List")
], -1))
const _hoisted_29 = { class: "warning-list-data-box" }
const _hoisted_30 = { class: "warning-list-item" }
const _hoisted_31 = { class: "detail-chart-box" }
const _hoisted_32 = { class: "chart-two-layer" }
const _hoisted_33 = { class: "heater-chart-box" }
const _hoisted_34 = { class: "chart-title-box-two" }
const _hoisted_35 = { class: "chart-title-text" }
const _hoisted_36 = { class: "heater-box" }
const _hoisted_37 = { class: "temp-chart-box" }
const _hoisted_38 = { class: "chart-title-box-two" }
const _hoisted_39 = { class: "chart-title-text" }
const _hoisted_40 = { class: "tank-box" }
const _hoisted_41 = { class: "weight-chart-box" }
const _hoisted_42 = { class: "chart-title-box" }
const _hoisted_43 = { class: "chart-title-text" }
const _hoisted_44 = { class: "weight-box" }
const _hoisted_45 = { class: "energy-chart-box" }
const _hoisted_46 = { class: "chart-title-box" }
const _hoisted_47 = { class: "chart-title-text" }
const _hoisted_48 = { class: "electric-box" }
const _hoisted_49 = { class: "energy-box" }
const _hoisted_50 = { class: "chart-total-title" }
const _hoisted_51 = { id: "energy-data" }
const _hoisted_52 = { class: "power-box" }
const _hoisted_53 = { class: "chart-total-title" }

import { userUseStore } from "@/store/user";
import { computed, ref } from "@vue/reactivity";
import { useRoute, useRouter } from "vue-router";
import AppImage from "@/components/AppImage.vue";
import OperationStep from "@/components/OperationStep.vue";
import HeaterChart from "@/components/HeaterChart.vue";
import WeightChart from "@/components/WeightChart.vue";
import TankChart from "@/components/TankChart.vue";
import PowerChart from "@/components/PowerChart.vue";
import "vue3-loading-overlay/dist/vue3-loading-overlay.css";
import { ROU_NAME } from "@/router/router.name";
import { configRefreshAxios } from "@/service/config.service";
import { dataGraphAxios, realTimeDataAxios } from "@/service/user.service";
import { onMounted } from "vue";
import _ from "lodash";
import Loading from "vue3-loading-overlay";
import { useOptionStore } from "@/store/option";
import { celsiusToFahrenheit, kgToPound } from "@/util/unit";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const userStore = userUseStore();
const router = useRouter();

const optionStore = useOptionStore();

const modelImageName = computed(() => {
  let modelImage = "model";
  switch (userStore.realTimeData[findMac.value]?.model) {
    case 1:
      modelImage = "ES-30L";
      break;
    case 2:
      modelImage = "ES-300L FAS LIFT";
      break;
    case 3:
      modelImage = "ES-60L";
      break;
    case 4:
      modelImage = "ES-80L";
      break;
    case 5:
      modelImage = "ES-150L";
      break;
    case 6:
      modelImage = "ES-150L Regular Lift";
      break;
    case 7:
      modelImage = "ES-300L";
      break;
    case 8:
      modelImage = "ES-300L Regular Lift";
      break;
    case 9:
      modelImage = "ES-500L";
      break;
    case 10:
      modelImage = "ES-500L Regular Lift";
      break;
    case 11:
      modelImage = "ES-500L FAS LIFT";
      break;
    case 21:
      modelImage = "ES-30L";
      break;
    case 22:
      modelImage = "ES-300L FAS LIFT";
      break;
    case 23:
      modelImage = "ES-60L";
      break;
    case 24:
      modelImage = "ES-80L R (RFID)";
      break;
    case 25:
      modelImage = "ES-150L";
      break;
    case 26:
      modelImage = "ES-150L R (RFID)";
      break;
    case 27:
      modelImage = "ES-300L";
      break;
    case 28:
      modelImage = "ES-300L R (RFID)";
      break;
    case 29:
      modelImage = "ES-500L";
      break;
    case 30:
      modelImage = "ES-500L Regular Lift";
      break;
    case 31:
      modelImage = "ES-500L FAS LIFT";
      break;
  }

  return `models/${modelImage}`;
});

const btnDisabled = ref(false);
const graphData = ref({
  tank: [] as any[],
  weight: [] as any[],
  power: [] as any[],
});

const loadings = computed(() => {
  if (graphData.value.power[0]) {
    return false;
  } else {
    return true;
  }
});

const findMac = computed(() => {
  if (userStore.realTimeData[0]) {
    const idx = userStore.findMac(String(route.query.mac));
    console.log(`finemac : ${idx}`);
    return idx;
  } else {
    return 0;
  }
});

const beforeGraph = async (mac: string) => {
  const graph = await dataGraphAxios(mac);
  graphData.value.tank = _.map(graph, (item) => {
    return {
      time: item.T,
      temp: item.TT,
    };
  });
  graphData.value.weight = _.map(graph, (item) => {
    return {
      time: item.T,
      weight: item.WT,
    };
  });
  graphData.value.power = _.map(graph, (item) => {
    return {
      time: item.T,
      power: item.TAP,
    };
  });
};

const modelName = computed(() => {
  if (userStore.realTimeData[0]) {
    if (userStore.realTimeData[findMac.value].model === 1) {
      return "ES-30";
    } else if (userStore.realTimeData[findMac.value].model === 2) {
      return "ES-300L FAS LIFT";
    } else if (userStore.realTimeData[findMac.value].model === 3) {
      return "ES-60L";
    } else if (userStore.realTimeData[findMac.value].model === 4) {
      return "ES-80L";
    } else if (userStore.realTimeData[findMac.value].model === 5) {
      return "ES-150L";
    } else if (userStore.realTimeData[findMac.value].model === 6) {
      return "ES-150L Regular Lift";
    } else if (userStore.realTimeData[findMac.value].model === 7) {
      return "ES-300L";
    } else if (userStore.realTimeData[findMac.value].model === 8) {
      return "ES-300L Regular Lift";
    } else if (userStore.realTimeData[findMac.value].model === 9) {
      return "ES-500L";
    } else if (userStore.realTimeData[findMac.value].model === 10) {
      return "ES-500L Regular Lift";
    } else if (userStore.realTimeData[findMac.value].model === 11) {
      return "ES-500L FAS LIFT";
    } else if (userStore.realTimeData[findMac.value].model === 21) {
      return "ES-30 R";
    } else if (userStore.realTimeData[findMac.value].model === 22) {
      return "ES-300L FAS LIFT R";
    } else if (userStore.realTimeData[findMac.value].model === 23) {
      return "ES-60L R";
    } else if (userStore.realTimeData[findMac.value].model === 24) {
      return "ES-80L R";
    } else if (userStore.realTimeData[findMac.value].model === 25) {
      return "ES-150L R";
    } else if (userStore.realTimeData[findMac.value].model === 26) {
      return "ES-150L Regular Lift R";
    } else if (userStore.realTimeData[findMac.value].model === 27) {
      return "ES-300L R";
    } else if (userStore.realTimeData[findMac.value].model === 28) {
      return "ES-300L Regular Lift R";
    } else if (userStore.realTimeData[findMac.value].model === 29) {
      return "ES-500L R";
    } else if (userStore.realTimeData[findMac.value].model === 30) {
      return "ES-500L Regular Lift R";
    } else if (userStore.realTimeData[findMac.value].model === 31) {
      return "ES-500L FAS LIFT R";
    } else {
      console.log(
        `현재 Model Number : ${userStore.realTimeData[findMac.value].model}`
      );
    }
  }
});

const switchStatus = computed(() => {
  if (userStore.realTimeData[0]) {
    if (userStore.realTimeData[findMac.value].main_switch_on === 1) {
      return "switch_on";
    }
    if (userStore.realTimeData[findMac.value].main_switch_on === 0) {
      return "switch_off";
    }
  }
});
const cycleStatus = computed(() => {
  if (userStore.realTimeData[0]) {
    if (userStore.realTimeData[findMac.value].cycle_status === 1) {
      return "status_icon";
    }
    if (userStore.realTimeData[findMac.value].cycle_status === 0) {
      return "status_icon_stop";
    }
  }
});

const cycleCount = computed(() => {
  if (userStore.realTimeData[0]) {
    return String(userStore.realTimeData[findMac.value].cycle_count);
  }
});

const dryTime = computed(() => {
  if (userStore.realTimeData[0]) {
    let dryTimeText = "";
    const time = userStore.realTimeData[findMac.value].remain_dry_time;
    const hour = Math.floor(time / 60);
    const minute = time % 60;
    if (time === 0) {
      return "00 : 00";
    }

    if (hour > 9) {
      if (minute > 9) {
        dryTimeText = `${String(hour)} : ${String(minute)}`;
      } else {
        dryTimeText = `${String(hour)} : 0${String(minute)}`;
      }
    } else {
      if (minute > 9) {
        dryTimeText = `0${String(hour)} : ${String(minute)}`;
      } else {
        dryTimeText = `0${String(hour)} : 0${String(minute)}`;
      }
    }
    return dryTimeText;
  }
});

const dischargeTime = computed(() => {
  if (userStore.realTimeData[0]) {
    let disTimeText = "";
    const time = userStore.realTimeData[findMac.value].remain_discharge_time;
    const hour = Math.floor(time / 60);
    const minute = time % 60;
    if (time === 0) {
      return "00 : 00";
    }

    if (hour > 9) {
      if (minute > 9) {
        disTimeText = `${String(hour)} : ${String(minute)}`;
      } else {
        disTimeText = `${String(hour)} : 0${String(minute)}`;
      }
    } else {
      if (minute > 9) {
        disTimeText = `0${String(hour)} : ${String(minute)}`;
      } else {
        disTimeText = `0${String(hour)} : 0${String(minute)}`;
      }
    }
    return disTimeText;
  }
});

const activeEnergy = computed(() => {
  if (userStore.realTimeData[0]) {
    return `${userStore.realTimeData[findMac.value].total_active_energy.toFixed(
      3
    )} kW`;
  }
});
const nowWeight = computed(() => {
  if (userStore.realTimeData[0]) {
    if (optionStore.$state.unitSystem === "metric") {
      return ` ${userStore.realTimeData[findMac.value].weight} Kg`;
    } else {
      return ` ${kgToPound(
        userStore.realTimeData[findMac.value].weight
      ).toFixed(2)} lb`;
    }
  }
});
const nowTemp = computed(() => {
  if (userStore.realTimeData[0]) {
    if (optionStore.$state.unitSystem === "metric") {
      return `${userStore.realTimeData[findMac.value].tank_temperature} ℃`;
    } else {
      return `${celsiusToFahrenheit(
        userStore.realTimeData[findMac.value].tank_temperature
      )} °F`;
    }
  }
});
const nowPower = computed(() => {
  if (userStore.realTimeData[0]) {
    return `${userStore.realTimeData[findMac.value].total_active_power.toFixed(
      3
    )} kWh`;
  }
});
const barData = computed(() => {
  if (userStore.realTimeData[0]) {
    const list = userStore.barChartData;
    return list[findMac.value];
  }
});

/*

 status:
          item.status === 2 ? "Error" : item.status === 3 ? "Connect Loss" : "",
      };

*/

const warningList = computed(() => {
  const list: string[] = [];
  let idx = 0;
  switch (userStore.realTimeData[findMac.value].status) {
    case 3:
      list.push("connect_loss");
      break;
    default:
      idx = list.findIndex(() => {
        "connect_loss";
      });
      if (idx > -1) {
        list.splice(idx, 0);
        idx = 0;
      }
  }
  switch (userStore.realTimeData[findMac.value].error_input_weight_overload) {
    case 1:
      list.push("error_input_weight_overload");
      break;
    default:
      idx = list.findIndex(() => {
        "error_input_weight_overload";
      });
      if (idx > -1) {
        list.splice(idx, 0);
        idx = 0;
      }
  }
  switch (userStore.realTimeData[findMac.value].error_oil_bi_metal) {
    case 1:
      list.push("error_oil_bi_metal");
      break;
    default:
      idx = list.findIndex(() => {
        "error_oil_bi_metal";
      });
      if (idx > -1) {
        list.splice(idx, 0);
        idx = 0;
      }
  }
  switch (userStore.realTimeData[findMac.value].error_air_bi_metal) {
    case 1:
      list.push("error_air_bi_metal");
      break;
    default:
      idx = list.findIndex(() => {
        "error_air_bi_metal";
      });
      if (idx > -1) {
        list.splice(idx, 0);
        idx = 0;
      }
  }
  switch (userStore.realTimeData[findMac.value].error_motor_overload) {
    case 1:
      list.push("error_motor_overload");
      break;
    default:
      idx = list.findIndex(() => {
        "error_motor_overload";
      });
      if (idx > -1) {
        list.splice(idx, 0);
        idx = 0;
      }
  }
  switch (
    userStore.realTimeData[findMac.value].error_blower_pump_fan_overload
  ) {
    case 1:
      list.push("error_blower_pump_fan_overload");
      break;
    default:
      idx = list.findIndex(() => {
        "error_blower_pump_fan_overload";
      });
      if (idx > -1) {
        list.splice(idx, 0);
        idx = 0;
      }
  }
  switch (
    userStore.realTimeData[findMac.value].error_tank_temperature_over_heating
  ) {
    case 1:
      list.push("error_tank_temperature_over_heating");
      break;
    default:
      idx = list.findIndex(() => {
        "error_tank_temperature_over_heating";
      });
      if (idx > -1) {
        list.splice(idx, 0);
        idx = 0;
      }
  }
  switch (
    userStore.realTimeData[findMac.value].error_oil_heater_1_over_heating
  ) {
    case 1:
      list.push("error_oil_heater_1_over_heating");
      break;
    default:
      idx = list.findIndex(() => {
        "error_oil_heater_1_over_heating";
      });
      if (idx > -1) {
        list.splice(idx, 0);
        idx = 0;
      }
  }
  switch (
    userStore.realTimeData[findMac.value].error_oil_heater_2_over_heating
  ) {
    case 1:
      list.push("error_oil_heater_2_over_heating");
      break;
    default:
      idx = list.findIndex(() => {
        "error_oil_heater_2_over_heating";
      });
      if (idx > -1) {
        list.splice(idx, 0);
        idx = 0;
      }
  }
  switch (
    userStore.realTimeData[findMac.value].error_air_heater_1_over_heating
  ) {
    case 1:
      list.push("error_air_heater_1_over_heating");
      break;
    default:
      idx = list.findIndex(() => {
        "error_air_heater_1_over_heating";
      });
      if (idx > -1) {
        list.splice(idx, 0);
        idx = 0;
      }
  }
  switch (
    userStore.realTimeData[findMac.value].error_air_heater_2_over_heating
  ) {
    case 1:
      list.push("error_air_heater_2_over_heating");
      break;
    default:
      idx = list.findIndex(() => {
        "error_air_heater_2_over_heating";
      });
      if (idx > -1) {
        list.splice(idx, 0);
        idx = 0;
      }
  }
  switch (
    userStore.realTimeData[findMac.value].error_discharge_heater_over_heating
  ) {
    case 1:
      list.push("error_discharge_heater_over_heating");
      break;
    default:
      idx = list.findIndex(() => {
        "error_discharge_heater_over_heating";
      });
      if (idx > -1) {
        list.splice(idx, 0);
        idx = 0;
      }
  }
  switch (userStore.realTimeData[findMac.value].error_emergency_stop) {
    case 1:
      list.push("error_emergency_stop");
      break;
    default:
      idx = list.findIndex(() => {
        "error_emergency_stop";
      });
      if (idx > -1) {
        list.splice(idx, 0);
        idx = 0;
      }
  }
  switch (userStore.realTimeData[findMac.value].error_lift_hydric_motor) {
    case 1:
      list.push("Error Lift Hydric Motor");
      break;
    default:
      idx = list.findIndex(() => {
        "Error Lift Hydric Motor";
      });
      if (idx > -1) {
        list.splice(idx, 0);
        idx = 0;
      }
  }
  switch (
    userStore.realTimeData[findMac.value].error_in_let_one_movement_error
  ) {
    case 1:
      list.push("Error InLet Door 1 Movement");
      break;
    default:
      idx = list.findIndex(() => {
        "Error InLet Door 1 Movement";
      });
      if (idx > -1) {
        list.splice(idx, 0);
        idx = 0;
      }
  }
  switch (
    userStore.realTimeData[findMac.value].error_in_let_two_movement_error
  ) {
    case 1:
      list.push("Error InLet Door 2 Movement");
      break;
    default:
      idx = list.findIndex(() => {
        "Error InLet Door 2 Movement";
      });
      if (idx > -1) {
        list.splice(idx, 0);
        idx = 0;
      }
  }
  switch (
    userStore.realTimeData[findMac.value]
      .error_run_button_pressed_during_operation
  ) {
    case 1:
      list.push("Error Run Button Pressed During");
      break;
    default:
      idx = list.findIndex(() => {
        "Error Run Button Pressed During";
      });
      if (idx > -1) {
        list.splice(idx, 0);
        idx = 0;
      }
  }
  switch (
    userStore.realTimeData[findMac.value].error_inlet_door_open_during_operation
  ) {
    case 1:
      list.push("Error Inlet Door Open During");
      break;
    default:
      idx = list.findIndex(() => {
        "Error Inlet Door Open During";
      });
      if (idx > -1) {
        list.splice(idx, 0);
        idx = 0;
      }
  }
  switch (userStore.realTimeData[findMac.value].error_main_switch_turn_on) {
    case 1:
      list.push("Error Main Switch On");
      break;
    default:
      idx = list.findIndex(() => {
        "Error Main Switch On";
      });
      if (idx > -1) {
        list.splice(idx, 0);
        idx = 0;
      }
  }
  return list;
});

// const model = Number(userStore.realTimeData[findMac.value].model);
// , model: number
const searchGo = (mac: string) => {
  router.push({ name: ROU_NAME.SEARCH, query: { mac: mac } });
};

const reFreshData = async () => {
  await configRefreshAxios(String(route.query.mac), "re").then(() => {
    realTimeDataAxios();
  });
  console.log("reFreshData");
  btnDisabled.value = true;
  setTimeout(() => {
    btnDisabled.value = false;
  }, 1000 * 15);
};

onMounted(() => {
  beforeGraph(String(route.query.mac));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_unref(userStore).realTimeData[0])
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  class: "refresh-btn",
                  disabled: btnDisabled.value,
                  onClick: reFreshData
                }, [
                  (!btnDisabled.value)
                    ? (_openBlock(), _createBlock(AppImage, {
                        key: 0,
                        name: "refresh_icon"
                      }))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_5),
                _createElementVNode("span", null, _toDisplayString(_unref(userStore).realTimeData[_unref(findMac)].site_name), 1),
                _createElementVNode("div", {
                  class: "search-btn",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (
              searchGo(String(_unref(route).query.mac))
              // Number(userStore.realTimeData[findMac].model)
            ))
                }, [
                  _createVNode(AppImage, { name: "search_icon" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(AppImage, {
                class: "detail-model-img",
                name: _unref(modelImageName)
              }, null, 8, ["name"]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", null, _toDisplayString(_unref(modelName)), 1)
              ])
            ]),
            (_unref(userStore).realTimeData[_unref(findMac)].status === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("normal")), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(userStore).realTimeData[_unref(findMac)].status === 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("error")), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(userStore).realTimeData[_unref(findMac)].status === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("warning")), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", null, [
                _createVNode(AppImage, {
                  name: "main_switch_icon",
                  class: "main-side-icon"
                }),
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("switch")), 1),
                _createVNode(AppImage, {
                  class: "main-side-data",
                  name: _unref(switchStatus)
                }, null, 8, ["name"])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", null, [
                _createVNode(AppImage, {
                  name: "cycle_status",
                  class: "main-side-icon"
                }),
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t("cycle_status")), 1),
                _createVNode(AppImage, {
                  class: "main-side-data",
                  name: _unref(cycleStatus)
                }, null, 8, ["name"])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", null, [
                _createVNode(AppImage, {
                  name: "cycle_count_icon",
                  class: "main-side-icon"
                }),
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("cycle_count")), 1),
                _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(cycleCount)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", null, [
                _createVNode(AppImage, {
                  name: "time_icon",
                  class: "main-side-icon"
                }),
                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("dry_time")), 1),
                _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(dryTime)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", null, [
                _createVNode(AppImage, {
                  name: "time_icon",
                  class: "main-side-icon"
                }),
                _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t("discharge_time")), 1),
                _createElementVNode("span", _hoisted_26, _toDisplayString(_unref(dischargeTime)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(warningList), (item, idx) => {
                  return (_openBlock(), _createElementBlock("div", { key: idx }, [
                    _createElementVNode("span", _hoisted_30, "Error : " + _toDisplayString(_ctx.$t(item)), 1)
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createVNode(OperationStep, {
              operation: _unref(userStore).realTimeData[_unref(findMac)].operation_step,
              status: _unref(userStore).realTimeData[_unref(findMac)].status,
              model: _unref(userStore).realTimeData[_unref(findMac)].model
            }, null, 8, ["operation", "status", "model"]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createVNode(AppImage, {
                    name: "heater_icon",
                    class: "chart-title-icon"
                  }),
                  _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t("heater_temperature")), 1)
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createVNode(_unref(Loading), {
                    active: _unref(loadings),
                    "is-full-page": false,
                    "background-color": "#2b323a",
                    color: "#8c98a5",
                    opacity: 0.8
                  }, null, 8, ["active", "opacity"]),
                  (graphData.value.power[0])
                    ? (_openBlock(), _createBlock(HeaterChart, {
                        key: 0,
                        data: _unref(barData),
                        size: "width:640px; height:100%;"
                      }, null, 8, ["data"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createVNode(AppImage, {
                    name: "tank_icon",
                    class: "chart-title-icon"
                  }),
                  _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t("tank_temperature")) + " : " + _toDisplayString(_unref(nowTemp)), 1)
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createVNode(_unref(Loading), {
                    active: _unref(loadings),
                    "is-full-page": false,
                    "background-color": "#2b323a",
                    color: "#8c98a5",
                    opacity: 0.8
                  }, null, 8, ["active", "opacity"]),
                  (graphData.value.tank[0])
                    ? (_openBlock(), _createBlock(TankChart, {
                        key: 0,
                        data_real: _unref(userStore).lineChartData[_unref(findMac)],
                        graph: graphData.value.tank,
                        size: "width:640px; height:100%;"
                      }, null, 8, ["data_real", "graph"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createVNode(AppImage, {
                  name: "weight_icon",
                  class: "chart-title-icon"
                }),
                _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t("weight")) + " : " + _toDisplayString(_unref(nowWeight)), 1)
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createVNode(_unref(Loading), {
                  active: _unref(loadings),
                  "is-full-page": false,
                  "background-color": "#2b323a",
                  color: "#8c98a5",
                  opacity: 0.8
                }, null, 8, ["active", "opacity"]),
                (graphData.value.weight[0])
                  ? (_openBlock(), _createBlock(WeightChart, {
                      key: 0,
                      data_real: _unref(userStore).lineChartData[_unref(findMac)],
                      graph: graphData.value.weight,
                      size: "width:1300px; height:100%;"
                    }, null, 8, ["data_real", "graph"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _createVNode(AppImage, {
                  name: "energy_icon",
                  class: "chart-title-icon"
                }),
                _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.$t("active_electric")), 1)
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.$t("active_energy")), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_51, _toDisplayString(_unref(activeEnergy)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createVNode(_unref(Loading), {
                    active: _unref(loadings),
                    "is-full-page": false,
                    "background-color": "#2b323a",
                    color: "#8c98a5",
                    opacity: 0.8
                  }, null, 8, ["active", "opacity"]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.$t("active_power")) + " : " + _toDisplayString(_unref(nowPower)), 1)
                  ]),
                  (graphData.value.power[0])
                    ? (_openBlock(), _createBlock(PowerChart, {
                        key: 0,
                        data_real: _unref(userStore).lineChartData[_unref(findMac)],
                        graph: graphData.value.power,
                        size: "width:1080px; height:100%;"
                      }, null, 8, ["data_real", "graph"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})